import BaseItemView from 'app/src/views/base/BaseItemView';
import Keyboard from 'app/Keyboard';
import Format from 'app/src/data/Format';
import Decimal from 'app/src/data/base/Decimal';
import giftCardRefundTemplate from './templates/gift-card-refund-template.hbs';
import giftCardTemplate from './templates/gift-card-payment-template.hbs';

const _Events = {
  CANCEL_BUTTON_CLICKED: 'cancel:button:clicked',
  GIFT_CARD_PAYMENT_CHANGED: 'gift:card:payment:changed',
  GIFT_CARD_PAYMENT_REQUESTED: 'gift:card:payment:requested',
};

// configure
let View = BaseItemView.extend({
  getTemplate() {
    // select the template based on whether or not we're refunding
    if (this.viewData.isRefundSale) {
      return giftCardRefundTemplate;
    }
    return giftCardTemplate;
  },

  ui: {
    amountInput: '#gift_card_amount',
    cancelButton: '#chargeGiftCardCancelButton',
    refundCancelButton: '#refundGiftCardCancelButton',
    chargeButton: '#chargeGiftCardChargeButton',
    refundButton: '#refundGiftCardRefundButton',
  },

  events: {
    'keypress @ui.amountInput': 'onAmountKeypress',
    'change @ui.amountInput': 'onAmountChanged',
    'click @ui.chargeButton': 'onChargeOrRefundButtonClicked',
    'click @ui.refundButton': 'onChargeOrRefundButtonClicked',
  },

  triggers: {
    'click @ui.cancelButton': _Events.CANCEL_BUTTON_CLICKED,
    'click @ui.refundCancelButton': _Events.CANCEL_BUTTON_CLICKED,
  },
});

// Defined
export default class PaymentGiftCardView extends View {
  static get Events() {
    return _Events;
  }

  /**
   * Event handler for when a key is pressed in the gift card payment amount input.  When the
   * enter key is pressed an event is triggered.
   *
   * @param event {Event} The triggering DOM event
   */
  onAmountKeypress(event) {
    if (event.keyCode === Keyboard.KeyCode.ENTER) {
      this.trigger(
        _Events.GIFT_CARD_PAYMENT_REQUESTED,
        Format.parseDecimal(this.ui.amountInput.val(), new Decimal(0))
      );
    }
  }

  /**
   * Event handler for when the payment amount changes.
   */
  onAmountChanged() {
    this.trigger(_Events.GIFT_CARD_PAYMENT_CHANGED, Format.parseDecimal(this.ui.amountInput.val()));
  }

  /**
   * Event handler for when the 'Charge' button is clicked.
   */
  onChargeOrRefundButtonClicked() {
    this.trigger(
      _Events.GIFT_CARD_PAYMENT_REQUESTED,
      Format.parseDecimal(this.ui.amountInput.val())
    );
  }

  /**
   * Sets the value of the payment amount input field.
   *
   * @param amount {string|number|Decimal}    The new input field value
   */
  setPaymentAmount(amount) {
    let paymentAmount = Format.formatMoney(amount, 0, false);

    this.ui.amountInput.val(paymentAmount);
  }
}
